/**
 * supportUnreadStore
 * Contagem de mensagens de suporte não lidas pelo Adm — vive fora do componente da navbar
 * de propósito: `MainAppBar` é remontado a cada troca de página (é o `PageShell` que embrulha
 * `PageLayout`), e um hook local reconectaria o socket e reentraria na sala toda vez,
 * abrindo uma corrida entre "entrar na sala" e "marcar como lida" — quem chegasse primeiro
 * decidia se o aviso em tempo real chegava ou só no próximo ciclo de polling. Um store module-
 * level assina o socket uma única vez, na primeira vez que alguém com permissão precisa dele.
 *
 * @version 2025.1.0
 */
import { create } from 'zustand';
import { getSocket } from '../services/socket';
import { supportChatService } from '../services/supportChatService';

interface SupportUnreadState {
  count: number;
  initialized: boolean;
  refresh: () => Promise<void>;
  init: () => void;
}

export const useSupportUnreadStore = create<SupportUnreadState>((set, get) => ({
  count: 0,
  initialized: false,

  refresh: async () => {
    try {
      const total = await supportChatService.getUnreadCount();
      set({ count: total });
    } catch {
      // Silencioso: um balão de contagem não deve gerar toast de erro pela tela toda.
    }
  },

  init: () => {
    if (get().initialized) return;
    set({ initialized: true });

    const socket = getSocket();
    const join = () => socket.emit('join:support-inbox');
    socket.on('connect', join);
    socket.on('support:message', () => void get().refresh());
    if (socket.connected) join();

    // Rede de segurança: cobre o socket caído e qualquer aviso perdido por corrida de rede.
    setInterval(() => void get().refresh(), 30000);

    void get().refresh();
  },
}));
